import React from 'react'

import { ContextualMenu, MenuDivider, MenuEntry, Stack } from '@procsea/design-system'

import { useCurrentMembership, useUser } from 'src/contexts/userContext'
import { getMembershipName } from 'src/utils'

import MembershipContextMenuContent from './MembershipContextMenuContent/MembershipContextMenuContent'

const MembershipContextMenu = () => {
  const user = useUser()
  const currentMembership = useCurrentMembership()
  const currentMembershipName = getMembershipName(currentMembership)

  if (!user || user.memberships.length === 1) {
    return <div />
  }

  return (
    <Stack spacing="small">
      <ContextualMenu
        button={
          <MenuEntry
            config={{ disableActiveState: true }}
            data-e2e="menu-entry-membership"
            hasChevron
            icon="shop"
            label={currentMembershipName}
          />
        }
        data-e2e="membership-context-menu"
        fitContent
        offset={[-37, 0]}
        placement="right-start"
        fallbackPlacements={['auto']}
      >
        <MembershipContextMenuContent />
      </ContextualMenu>
      <MenuDivider />
    </Stack>
  )
}

export default MembershipContextMenu
